import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dbae05c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Für eine Bestattung mit den ausgewählten Optionen sollten Sie etwa diese Summe einplanen:", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("ca. ")
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = { class: "display-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" inkl. MwSt.")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Darin enthalten sind ")
const _hoisted_10 = { class: "cost-external" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" und ")
const _hoisted_12 = { class: "cost-internal" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Bei der angegebenen Summe handelt es sich um eine erste Schätzung."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Für ein ausführliches Angebot sprechen Sie uns gerne an! ")
], -1))
const _hoisted_14 = { class: "card-footer d-flex justify-items-around" }
const _hoisted_15 = {
  class: "btn btn--print mx-auto btn-primary",
  type: "button"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas far fal fa-print" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Übersicht drucken ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn--return-call mx-auto btn-primary",
  "data-bs-target": "#callback-modal",
  "data-bs-toggle": "modal",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas far fal fa-phone" }),
  /*#__PURE__*/_createTextVNode(" Rückruf anfordern ")
], -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  id: "callback-modal",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_24 = { class: "modal-dialog" }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    id: "quote-modal-label",
    class: "modal-title"
  }, "Rückruf anfordern"),
  /*#__PURE__*/_createElementVNode("button", {
    "aria-label": "Close",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    type: "button"
  })
], -1))
const _hoisted_27 = { class: "modal-body" }
const _hoisted_28 = {
  key: 1,
  class: "spinner-container"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Rückruf wird angefordert...")
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert alert-danger text-center" }, [
  /*#__PURE__*/_createTextVNode(" Ihre Anfrage konnte nicht verschickt werden."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Bitte versuchen Sie es später erneut! ")
], -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 3,
  class: "alert alert-success text-center m-1"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Vielen Dank für Ihr Interesse!")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Wir bemühen uns, Sie im gewünschten Zeitraum zu kontaktieren.", -1))
const _hoisted_37 = { class: "modal-footer" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary mr-2",
  "data-bs-dismiss": "modal",
  type: "button"
}, "Abbrechen", -1))
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  id: "quote-modal",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_41 = { class: "modal-dialog modal-lg" }
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    id: "quote-modal-label",
    class: "modal-title"
  }, "Angebot anfordern"),
  /*#__PURE__*/_createElementVNode("button", {
    "aria-label": "Close",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    type: "button"
  })
], -1))
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "spinner-container" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Angebot wird angefordert...")
], -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "alert alert-danger text-center" }, [
  /*#__PURE__*/_createTextVNode(" Ihre Anfrage konnte nicht verschickt werden."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Bitte versuchen Sie es später erneut! ")
], -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "alert alert-success text-center m-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Vielen Dank für Ihre Anfrage!")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Wir melden uns bei Ihnen, sobald wir ein Angebot erstellt haben."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Eine Kopie Ihrer Anfrage wird automatisch an die von Ihnen angegebene E-Mail-Adresse gesendet. ")
], -1))
const _hoisted_53 = { class: "modal-footer" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary mr-2",
  "data-bs-dismiss": "modal",
  type: "button"
}, "Abbrechen", -1))
const _hoisted_55 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_callback_form = _resolveComponent("callback-form")!
  const _component_quote_request_form = _resolveComponent("quote-request-form")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.calculatedPriceForDisplay), 1),
          _hoisted_7
        ])
      ]),
      (_ctx.calculatedExternalPricePartForDisplay !== '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.calculatedExternalPricePartForDisplay) + " Fremdkosten", 1),
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.calculatedInternalPricePartForDisplay) + " Eigenkosten.", 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_15, _hoisted_18)), [
        [_directive_print, _ctx.printOptions]
      ]),
      _hoisted_19,
      _createElementVNode("button", {
        disabled: _ctx.hasQuoteRequestSucceeded,
        class: "btn btn-primary mx-auto",
        "data-bs-target": "#quote-modal",
        "data-bs-toggle": "modal",
        type: "button"
      }, [
        (_ctx.hasQuoteRequestSucceeded)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Angebot angefordert"))
          : (_openBlock(), _createElementBlock("span", _hoisted_22, "Angebot anfordern"))
      ], 8, _hoisted_20)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            (!_ctx.isCallbackRequestInProgress && !_ctx.hasCallbackRequestFinished)
              ? (_openBlock(), _createBlock(_component_callback_form, {
                  key: 0,
                  modelValue: _ctx.callbackFormData,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.callbackFormData) = $event)),
                  "callback-form-submit": _ctx.callbackFormSubmit,
                  values: _ctx.callbackFormData,
                  onFormChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFormValid = $event))
                }, null, 8, ["modelValue", "callback-form-submit", "values"]))
              : (_ctx.isCallbackRequestInProgress && !_ctx.hasCallbackRequestFinished)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                : (_ctx.hasCallbackRequestFinished && _ctx.hasCallbackRequestFailed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                  : (_ctx.hasCallbackRequestFinished && _ctx.hasCallbackRequestSucceeded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _hoisted_36,
                        _createElementVNode("p", null, "Ihr Team von " + _toDisplayString(_ctx.morticianName), 1)
                      ]))
                    : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("button", {
              disabled: !_ctx.isFormValid,
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleModalOk && _ctx.handleModalOk(...args)))
            }, _toDisplayString(_ctx.hasCallbackRequestFinished ? (_ctx.hasCallbackRequestSucceeded ? 'Schließen' : 'Erneut versuchen') : 'Absenden'), 9, _hoisted_39)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _withDirectives(_createVNode(_component_quote_request_form, {
              ref: "quoteForm",
              modelValue: _ctx.quoteRequestInfo,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quoteRequestInfo) = $event)),
              values: _ctx.quoteRequestInfo,
              onSubmitted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dispatchQuoteRequest())),
              onValidationChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.quoteFormValid = $event))
            }, null, 8, ["modelValue", "values"]), [
              [_vShow, !_ctx.isQuoteRequestInProgress && !_ctx.hasQuoteRequestFinished]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_45, _hoisted_47, 512), [
              [_vShow, _ctx.isQuoteRequestInProgress]
            ]),
            _withDirectives(_createElementVNode("div", null, _hoisted_49, 512), [
              [_vShow, _ctx.hasQuoteRequestFinished && _ctx.hasQuoteRequestFailed]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _hoisted_52,
              _createElementVNode("p", null, "Ihr Team von " + _toDisplayString(_ctx.morticianName), 1)
            ], 512), [
              [_vShow, _ctx.hasQuoteRequestFinished && _ctx.hasQuoteRequestSucceeded]
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("button", {
              disabled: !_ctx.quoteFormValid || _ctx.isQuoteRequestInProgress || _ctx.hasQuoteRequestFailed,
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleQuoteModalOk && _ctx.handleQuoteModalOk(...args)))
            }, _toDisplayString(_ctx.hasQuoteRequestSucceeded ? 'Schließen' : 'Absenden'), 9, _hoisted_55)
          ])
        ])
      ])
    ])
  ]))
}